import { useState } from "react";
import { LogIn } from "lucide-react";
import LoginModal from "../LoginModal";
import AccountUpgradeModal from "../AccountUpgradeModal";

// Shown instead of a checkout to guests: purchases live on an account, so a
// guest who clears their browser would lose what they paid for.
// `onSignedIn` runs once they have signed in or created an account.
export default function SignInGate({ what = "buy coins", onSignedIn, onModalChange }) {
  const [modal, setModal] = useState(null); // "login" | "signup" | null

  const open = (next) => {
    setModal(next);
    onModalChange?.(!!next);
  };
  const done = () => {
    open(null);
    onSignedIn?.();
  };

  return (
    <>
      <div className="py-4 flex flex-col items-center text-center">
        <div className="w-14 h-14 rounded-2xl bg-brand-accentMuted flex items-center justify-center mb-4">
          <LogIn className="w-7 h-7 text-brand-accent" aria-hidden="true" />
        </div>
        <h3 className="text-lg font-bold text-brand-text">Sign in to {what}</h3>
        <p className="mt-2 text-sm leading-relaxed text-brand-textSecondary max-w-xs">
          You need a signed-in account so your purchase is saved safely and won't be lost if you clear your browser or switch devices.
        </p>
        <div className="w-full max-w-xs mt-6 space-y-2">
          <button
            type="button"
            onClick={() => open("signup")}
            className="w-full h-12 rounded-xl bg-brand-accent text-white font-semibold hover:bg-red-700 transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-accent"
          >
            Create account
          </button>
          <button
            type="button"
            onClick={() => open("login")}
            className="w-full h-12 rounded-xl border border-brand-border text-brand-text font-semibold hover:bg-brand-surface2 transition-colors"
          >
            Sign in
          </button>
        </div>
        <p className="mt-3 text-xs text-brand-textSecondary">Free to create, takes 10 seconds</p>
      </div>

      <LoginModal isOpen={modal === "login"} onClose={() => open(null)} onSuccess={done} onSwitchToSignUp={() => open("signup")} />
      <AccountUpgradeModal isOpen={modal === "signup"} onClose={() => open(null)} onSuccess={done} onSwitchToSignIn={() => open("login")} />
    </>
  );
}
